<template>
  <div>
    <iModal title="新增" v-model="showModal" class-name="common-ad-down" width="600px" :mask-closable="false" @on-cancel="cancel">
      <div class="admin-add">
        <div class="admin-add-content">
          <Form ref="formInline" :model="formInline" :rules="ruleInline" label-position="right" :label-width="120" @submit.native.prevent>
            <FormItem label="名称：" prop="name">
              <Input v-model="formInline.name" />
            </FormItem>
            <FormItem label="类型：" prop="type">
              <Select v-model="formInline.type">
                <Option v-for="item in needList" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
            <FormItem label="模板文件：" :required="true">
              <div class="my-upload">
                <Upload ref="upload" :default-file-list="defaultList" :on-success="handleSuccess" :headers="formHeaders" :before-upload="handleBeforeUpload" :action="uploadUrl" :format="fileType" :on-format-error="formatError" :on-exceeded-size="handleMaxSize" :max-size="51200">
                  <Button icon="ios-cloud-upload-outline" :disabled="uploading">上传文件</Button>
                </Upload>
              </div>
            </FormItem>
            <FormItem label="文件描述：" prop="description">
              <Input type="textarea" :rows="4" v-model="formInline.description" placeholder="请输入文本内容" />
            </FormItem>
            <FormItem label="需要上传回执：">
              <Checkbox size="large" v-model="formInline.isNeedReceipt">
                <span style="display: inline-block;width: 10px;"></span>
              </Checkbox>
            </FormItem>
            <FormItem label="显示顺序：">
              <InputNumber :max="9999" :min="0" v-model="formInline.showIndex"></InputNumber>
              <p style="font-size:12px;">（数字越小显示越靠前）</p>
            </FormItem>
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" :loading="loading" @click="handleSubmit('formInline')">确定</Button>
        <Button @click="cancel">取消</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "ad-home-down",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    editInfo: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data () {
    return {
      loading: false,
      showModal: false,
      formInline: {
        path: "",
        name: "",
        type: "",
        isNeedReceipt: false,
        description: "",
        showIndex: 0
      },
      ruleInline: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        type: [{ type: 'number', required: true, message: "请选择类型", trigger: "blur" }],
      },
      uploadList: [],
      defaultList: [],
      visible: false,
      needList: [
        {
          label: '下载需求表',
          value: 0
        },
        {
          label: '承诺书',
          value: 1
        },
        {
          label: '展位装修',
          value: 2
        },
        {
          label: '运输服务',
          value: 3
        },
        {
          label: '会展会务服务',
          value: 4
        },
      ],
      fileType: [
        "doc",
        "docx",
        "png",
        "jpg",
        "jpeg",
        "pdf",
        "ppt",
        "pptx",
        "txt",
        "unkown",
        "xls",
        "xlsx",
        "zip",
        "js",
        "json",
        "zip",
        "txt",
        "psd"
      ],
      uploading: false,
    };
  },
  watch: {
    show (val, oldVal) {
      this.showModal = val;
      if (!val) this.$emit("close");
      this.init();
    },
  },
  computed: {
    ...mapGetters({
      uploadUrl: "getUploadUrl2",
      uploadVideoUrl: "getUploadVideoUrl",
      formHeaders: "getFormHeaders",
      exhibition: "hostSetModule/getHostExhibition"
    })
  },
  created () { },
  methods: {
    ...mapActions({
      editExhibitionBaseNeedSettleInfo: "hostNeed/editExhibitionBaseNeedSettleInfo"
    }),
    init () {
      if (this.editInfo) {
        this.formInline.name = this.editInfo.name;
        this.formInline.isNeedReceipt = this.editInfo.isNeedReceipt;
        this.formInline.type = this.editInfo.type;
        this.formInline.description = this.editInfo.description;
        this.formInline.showIndex = this.editInfo.showIndex;
        if (this.editInfo.upFileUrl) {
          this.defaultList = [{
            name: this.editInfo.name,
            url: this.editInfo.upFileUrl,
            status: "finished",
            percentage: 100
          }];
          this.formInline.path = this.editInfo.upFileUrl;
        }
      }
    },
    // 查看上传图片
    handleView (name) {
      this.imgName = name;
      this.visible = true;
    },
    // 移除上传图片
    handleRemove (file) { },
    // 上传成功
    handleSuccess (res, file) {
      this.uploading = false;
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList = this.$refs.upload.fileList;
        this.formInline.path = file.url;
      }
    },
    async handleSubmit (name) {
      let form = this.formInline;
      let valid = await this.validForm(name);
      if (!valid) return;
      if (!form.path) {
        this.$Message.warning(`请上传文件！`);
        return;
      }
      let req = {
        Id: this.editInfo.id,
        SetValues: {
          Name: form.name,
          UpFileUrl: form.path,
          Description: form.description,
          ShowIndex: form.showIndex,
          Type: form.type,
          IsNeedReceipt: form.isNeedReceipt,
        }
      };
      this.loading = true;
      let bool = await this.editExhibitionBaseNeedSettleInfo(req).catch(err => {
        this.loading = false;
      });
      if (!bool) {
        this.loading = false;
        this.$Message.error("操作失败，请重新尝试");
      } else {
        this.cancel();
        this.$emit("finish");
        this.loading = false;
        this.$Message.success("操作成功！");
      }
    },
    // 上传数量
    handleBeforeUpload () {
      const limitNum = 1;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Message.warning(`一次最多上传${limitNum}个文件`);
      }
      if (check) {
        this.uploading = true;
      }
      return check;
    },
    validForm (name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    cancel () {
      this.formInline.title = "";
      this.formInline.link = "";
      this.formInline.showIndex = 0;
      this.uploadList = [];
      this.uploading = false;
      this.$refs.upload.fileList = [];
      this.$refs["formInline"].resetFields();
      this.$emit("close");
    },
    handleMaxSize (file) {
      this.uploading = false;
      this.$Message.warning(`文件大小超过限制, 请上传小于50M以下的文件`);
    },
    formatError (file) {
      this.uploading = false;
      this.$Message.warning(`文件格式错误，请重新上传`);
    }
  }
};
</script>

<style scoped lang="scss">
.admin-add {
  &-content {
    padding: 20px 40px 20px 20px;
  }
}
.admin-add {
  &-title {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
    font-size: 16px;
  }
  &-content {
    .submit {
      display: flex;
      justify-content: center;
      button {
        margin-left: -75px;
      }
    }
    img {
      width: 150px;
      height: 150px;
    }
  }
  .form-code-item {
    position: relative;
    .form-code-btn {
      position: absolute;
      right: 1px;
      width: 96px;
      top: 2px;
      border: none;
      outline: none;
      &:focus {
        box-shadow: none;
        border: none;
        outline: none;
      }
    }
  }
}
</style>
<style lang="scss">
.common-ad-down {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: 0;
  }
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  // IE10+ CSS styles go here
  .common-ad-down {
    display: block;
    .ivu-modal {
      top: 150px;
    }
  }
}
</style>
